import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

function BlogPost(props) {
    const { blogPost } = props;
    
    // Handle image URL - if it's a full URL, use it as is, otherwise prepend assets path
    const getImageUrl = (image) => {
        if (!image) return '';
        if (image.startsWith('http://') || image.startsWith('https://')) {
            return image;
        }
        return `/assets/img/blog/${image}`;
    };

    // Format date helper
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', { 
            day: '2-digit', 
            month: '2-digit', 
            year: 'numeric' 
        });
    };
    
    const slug = blogPost.slug;
    
    return (
        <>
            {/* Single Blog Post */}
            <div className="th-blog blog-single has-post-thumbnail">
                <div className="blog-img">
                    <Link to={`/blogs/${slug}`}>
                        <img src={getImageUrl(blogPost.cover_image)} alt="Blog" />
                    </Link>
                </div>
                <div className="blog-content">
                    <div className="blog-meta">
                        <Link className="author" to={`/blogs/${slug}`}>
                            <i className="fa-light fa-user" />
                            by {blogPost.author.name || blogPost.author.email || 'Unknown'}
                        </Link>
                        <Link to={`/blogs/${slug}`}>
                            <i className="fa-solid fa-calendar-days" />
                            {formatDate(blogPost.published_at)}
                        </Link>
                        <Link to={`/blogs/${slug}`}>
                            <img src="/assets/img/icon/map.svg" alt="" />
                            {blogPost.category.name}
                        </Link>
                    </div>
                    <h2 className="blog-title">
                        <Link to={`/blogs/${slug}`}>
                            {blogPost.title}
                        </Link>
                    </h2>
                    <p className="blog-text">
                        {blogPost.excerpt}
                    </p>
                </div>
            </div>
        </>
    )
}

export default BlogPost
